module.exports = __webpack_public_path__ + "assets/fonts/IBMPlexSerif-Regular.377f8314.ttf";